import { deserializeLexicalValue, serializeLexicalValue } from '../../lib/lexicalFunctions.js';

const baseMemoryScopeOptions = [
  { value: 'workflow', label: 'This Workflow' },
  { value: 'allWorkflows', label: 'All Workflows' }
];

export const memoryScopeOptions = [...baseMemoryScopeOptions, { value: 'environment', label: 'This Environment' }];
export const embeddedMemoryScopeOptions = [...baseMemoryScopeOptions, { value: 'installation', label: 'This Installation' }];

export const memorySavesOnOptions = [
  { value: 'success', label: 'Success' },
  { value: 'failure', label: 'Failure' },
  { value: 'always', label: 'Always' }
];

export const memoryExpiresOnOptions = [
  { value: 'never', label: 'Never' },
  { value: 1000 * 60 * 10, label: '10 Minutes' },
  { value: 1000 * 60 * 30, label: '30 Minutes' },
  { value: 1000 * 60 * 60, label: '1 Hour' },
  { value: 1000 * 60 * 60 * 3, label: '3 Hours' },
  { value: 1000 * 60 * 60 * 6, label: '6 Hours' },
  { value: 1000 * 60 * 60 * 12, label: '12 Hours' },
  { value: 1000 * 60 * 60 * 24, label: '1 Day' },
  { value: 1000 * 60 * 60 * 24 * 2, label: '2 Days' },
  { value: 1000 * 60 * 60 * 24 * 3, label: '3 Days' },
  { value: 1000 * 60 * 60 * 24 * 7, label: '1 Week' },
  { value: 1000 * 60 * 60 * 24 * 14, label: '2 Weeks' },
  { value: 1000 * 60 * 60 * 24 * 30, label: 'a Month' }
];

const memorySchema = ({ variables = [], steps = [] } = {}) => ({
  ai: {
    action: 'configureWorkflowStep',
    placeholder: 'Tell the AI how to configure memory settings',
    baseSuggestion: 'Tell AI to',
    baseDescription: 'You can ask AI to configure the memory settings for this step.'
  },
  fields: [
    {
      key: 'memory',
      name: 'Memory',
      description: 'The memory entries for the step.',
      path: 'options.memory',
      dataType: 'array',
      itemDataType: {
        type: 'object',
        properties: {
          key: {
            key: 'key',
            name: 'Key',
            description: 'The key for the memory entry.',
            path: 'key',
            dataType: 'string'
          },
          value: {
            key: 'value',
            name: 'Value',
            description: 'The value for the memory entry.',
            path: 'value',
            dataType: 'lexical',
            serializeValue: (value) => serializeLexicalValue(value, variables),
            deserializeValue: (value) => deserializeLexicalValue(value, steps)
          },
          scope: {
            key: 'scope',
            name: 'Scope',
            description: 'The scope for the memory entry.',
            path: 'scope',
            dataType: 'list',
            options: memoryScopeOptions,
            defaultValue: 'workflow',
            formatLabel: (value) => {
              return memoryScopeOptions.find((option) => option.value === value)?.label || embeddedMemoryScopeOptions.find((option) => option.value === value)?.label;
            }
          },
          savesOn: {
            key: 'savesOn',
            name: 'Saves On',
            description: 'The condition under which the memory entry is saved.',
            path: 'savesOn',
            dataType: 'list',
            options: memorySavesOnOptions,
            defaultValue: 'success',
            formatLabel: (value) => {
              return memorySavesOnOptions.find((option) => option.value === value)?.label;
            }
          },
          expiresOn: {
            key: 'expiresOn',
            name: 'Expires After',
            description: 'The time after which the memory entry expires.',
            path: 'expiresOn',
            dataType: 'list',
            options: memoryExpiresOnOptions,
            defaultValue: 'never',
            formatLabel: (value) => {
              return memoryExpiresOnOptions.find((option) => option.value === value)?.label;
            }
          }
        }
      }
    }
  ]
});

export default memorySchema;
